module.exports = __webpack_public_path__ + "static/media/bg.cfc5ed49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Wizard/img/bg.svg
// module id = 117
// module chunks = 8